// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"b7a3b784","186":"e1134c31","341":"8833aa2d","394":"b6a5adf9","444":"8c826980","455":"1d830d47","508":"8b03c829","726":"88ae6f2c","977":"b79cfa15"}[chunkId] + ".chunk.js";
};